<app-dashboard-header></app-dashboard-header>

<div class="schedules-content">
  <h1 class="page-title">Schedules</h1>
  
  <mat-card>
    <div class="card-header">
      <h2>Manage Schedules</h2>
      <button mat-flat-button class="action-button accent" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        Add Schedule
      </button>
    </div>

      <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>

      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>

      <div *ngIf="!loading && schedules.length > 0" class="table-container">
        <table mat-table [dataSource]="schedules" style="width: 100%;">

          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let schedule">{{ schedule.id }}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let schedule">
              {{ schedule.name }}
            </td>
          </ng-container>
          
          <!-- Version Pill Column -->
          <ng-container matColumnDef="versionPill">
            <th mat-header-cell *matHeaderCellDef>Version</th>
            <td mat-cell *matCellDef="let schedule">
              <ng-container *ngIf="recreatingScheduleIds.has(schedule.id); else versionDisplay">
                <span class="version-pill" style="background: transparent; color: #888;">
                  Generating new version ...
                </span>
              </ng-container>
              <ng-template #versionDisplay>
                <span *ngIf="schedule.currentVersionId" class="version-pill">
                  v{{ getCurrentVersionNumber(schedule) }}
                </span>
              </ng-template>
            </td>
          </ng-container>

          <!-- Current Version Column -->
          <ng-container matColumnDef="currentVersion">
            <th mat-header-cell *matHeaderCellDef>Current Version Name</th>
            <td mat-cell *matCellDef="let schedule">
              <span *ngIf="schedule.currentVersionId">
                {{ getCurrentVersionName(schedule) }}
              </span>
            </td>
          </ng-container>

          <!-- Resource Types Column -->
          <ng-container matColumnDef="resourceTypes">
            <th mat-header-cell *matHeaderCellDef>Resource Types</th>
            <td mat-cell *matCellDef="let schedule">
              {{ getResourceTypeNames(schedule.id) }}
            </td>
          </ng-container>

          <!-- Required Resource Types Column -->
          <ng-container matColumnDef="requiredResourceTypes">
            <th mat-header-cell *matHeaderCellDef>Required</th>
            <td mat-cell *matCellDef="let schedule">
              {{ getRequiredResourceTypeNames(schedule.id) }}
            </td>
          </ng-container>

          <!-- Primary Resource Type Column -->
          <ng-container matColumnDef="primaryResourceType">
            <th mat-header-cell *matHeaderCellDef>Primary</th>
            <td mat-cell *matCellDef="let schedule">
              {{ getPrimaryResourceTypeName(schedule) }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 400px;">Actions</th>
            <td mat-cell *matCellDef="let schedule" style="white-space: nowrap;">
              <button mat-icon-button color="primary" matTooltip="Edit" (click)="openEditDialog(schedule)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="accent" matTooltip="Constraints" (click)="navigateToConstraints(schedule, $event)">
                <mat-icon>rule</mat-icon>
              </button>
              <button mat-icon-button color="accent" matTooltip="Validate" (click)="validateSchedule(schedule, $event)">
                <mat-icon>check_circle</mat-icon>
              </button>
              <span
                [matTooltip]="getPdfExportTooltip(schedule)"
                style="display: inline-block;"
              >
                <button
                  mat-icon-button
                  color="primary"
                  (click)="openPdfExportDialog(schedule, $event)"
                  [disabled]="!schedule['itemsCount'] || schedule['itemsCount'] === 0 || exportingPdfScheduleIds.has(schedule.id)"
                  style="z-index: 3; position: relative;"
                >
                  <mat-icon *ngIf="!exportingPdfScheduleIds.has(schedule.id)">picture_as_pdf</mat-icon>
                  <span
                    *ngIf="exportingPdfScheduleIds.has(schedule.id)"
                    style="display: inline-block; width: 24px; height: 24px; vertical-align: middle;"
                  >
                    <mat-progress-spinner
                      diameter="24"
                      mode="indeterminate"
                      color="primary"
                      style="vertical-align: middle;"
                    ></mat-progress-spinner>
                  </span>
                </button>
              </span>
              <button mat-icon-button color="primary" matTooltip="Version History" (click)="openVersionPanel(schedule, $event)">
                <mat-icon>history</mat-icon>
              </button>
              <span
                [matTooltip]="getExportTooltip(schedule)"
                style="display: inline-block;"
              >
                <button
                  mat-icon-button
                  color="primary"
                  (click)="exportSchedule(schedule, $event)"
                  [disabled]="!schedule['externalKey'] || !schedule['itemsCount'] || schedule['itemsCount'] === 0 || exportingScheduleIds.has(schedule.id)"
                  style="z-index: 3; position: relative;"
                >
                  <mat-icon *ngIf="!exportingScheduleIds.has(schedule.id)">send</mat-icon>
                  <span
                    *ngIf="exportingScheduleIds.has(schedule.id)"
                    style="display: inline-block; width: 24px; height: 24px; vertical-align: middle;"
                  >
                    <mat-progress-spinner
                      diameter="24"
                      mode="indeterminate"
                      color="primary"
                      style="vertical-align: middle;"
                    ></mat-progress-spinner>
                  </span>
                </button>
              </span>
              <button
                mat-icon-button
                color="accent"
                matTooltip="Recreate Schedule"
                (click)="openRecreateDialog(schedule, $event)"
                [disabled]="recreatingScheduleIds.has(schedule.id)"
                style="z-index: 3; position: relative;"
              >
                <mat-icon *ngIf="!recreatingScheduleIds.has(schedule.id)">autorenew</mat-icon>
                <span
                  *ngIf="recreatingScheduleIds.has(schedule.id)"
                  style="display: inline-block; width: 24px; height: 24px; vertical-align: middle;"
                >
                  <mat-progress-spinner
                    diameter="24"
                    mode="indeterminate"
                    color="accent"
                    style="vertical-align: middle;"
                  ></mat-progress-spinner>
                </span>
              </button>
              <button
                mat-icon-button
                color="accent"
                matTooltip="Redeploy Lambda"
                (click)="redeployLambda(schedule, $event)"
                [disabled]="redeployingScheduleIds.has(schedule.id)"
                style="z-index: 3; position: relative;"
              >
                <mat-icon *ngIf="!redeployingScheduleIds.has(schedule.id)">cloud_upload</mat-icon>
                <span
                  *ngIf="redeployingScheduleIds.has(schedule.id)"
                  style="display: inline-block; width: 24px; height: 24px; vertical-align: middle;"
                >
                  <mat-progress-spinner
                    diameter="24"
                    mode="indeterminate"
                    color="accent"
                    style="vertical-align: middle;"
                  ></mat-progress-spinner>
                </span>
              </button>
              <button mat-icon-button color="warn" matTooltip="Delete" (click)="deleteSchedule(schedule)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns;"
            class="clickable-row"
            [class.disabled-row]="recreatingScheduleIds.has(row.id)"
            (click)="onRowClick($event, row)"
          ></tr>
        </table>
      </div>
      <!-- Single progress bar at the bottom if any regeneration is running -->
      <div
        *ngIf="recreatingScheduleIds.size > 0"
        class="schedule-recreate-progress-bar global-progress-bar"
        style="margin-top: 0; border-radius: 0 0 8px 8px;"
      ></div>
      <div *ngIf="!loading && schedules.length === 0" class="no-schedules">
        <mat-icon>info</mat-icon>
        <p>No schedules found. Click the 'Add Schedule' button to create your first schedule.</p>
      </div>
  </mat-card>
</div>

<app-dashboard-footer></app-dashboard-footer>
